import { TransferBaseRequestDto } from './transfer-base-request.dto';
import { TransferRecordIdentityKey } from './transfer-record-identity-key.dto';

export class TransferRecordDto extends TransferBaseRequestDto {
	public Workfile: any;
	public TransferRecord: TransferRecordIdentityKey[];
	public RecordId: string;

	public constructor(params: Required<TransferRecordDto>) {
		super({
			AuthenticationMethod: params.AuthenticationMethod,
			Environment: params.Environment
		});
		this.Workfile = params.Workfile;
		this.TransferRecord = params.TransferRecord;
		this.RecordId = params.RecordId;
	}
}
